module.exports = __webpack_public_path__ + "img/first-avater-1.43cea81.png";